import {
    ConfigurationTypes,
    RECEIVE_CONFIGURATION,
    REQUEST_CONFIGURATION,
    RECEIVE_CONFIGURATION_LOADER,
    GET_COUNTRY_LIST,
    SET_REDIRECT_TO_DASHBOARD,
    SET_CHILD_ACCOUNT_SWITCH_REDIRECT_URL,
    SET_LANGUAGE_OPTIONS,
    SET_ROUTE_LOADING,
    SET_CID_UNPAID_CHANNEL_DATA,
    RECEIVE_CONFIGURATION_DATA_LOADER,
    SET_SALES_TAX_DATA,
} from "./types";
import { AppThunkAction } from "..";
import * as httpClient from "../../util/httpClient";
import * as services from "../service";
import { defaultRetailer } from "../../components/Credit/CreditScore/contentCredit";

export const actionCreators = {
    requestRecaptchaSiteKey: (): AppThunkAction<ConfigurationTypes> => (dispatch, getState) => {
        let appState = getState();
        if (appState && appState.configurationState) {
            if (appState.configurationState.configuration.recaptchaSiteKey === "") {
                httpClient
                    .sendRequest("POST", `web/configuration/get-captcha-site-key`)
                    .then((data) => {
                        appState = getState();

                        if (data.siteKey && appState.configurationState) {
                            dispatch({
                                type: RECEIVE_CONFIGURATION,
                                configuration: {
                                    ...appState.configurationState.configuration,
                                    recaptchaSiteKey: data.siteKey,
                                },
                            });
                        } else {
                            appState = getState();
                            if (appState.configurationState) {
                                dispatch({
                                    type: RECEIVE_CONFIGURATION,
                                    configuration: {
                                        ...appState.configurationState.configuration,
                                        recaptchaSiteKey: "",
                                    },
                                });
                            }
                        }
                    })
                    .catch(function (error) {
                        appState = getState();
                        if (appState.configurationState) {
                            dispatch({
                                type: RECEIVE_CONFIGURATION,
                                configuration: {
                                    ...appState.configurationState.configuration,
                                    recaptchaSiteKey: "",
                                },
                            });
                        }
                    });

                dispatch({ type: REQUEST_CONFIGURATION });
            }
        }
    },

    requestPartnerConfig:
        (retailerCode?: string, lookupType?: string, lookupValue?: string): AppThunkAction<ConfigurationTypes> =>
            (dispatch, getState) => {
                const state = getState();

                if (state != null && state.configurationState != null && state.configurationState.isPartnerConfigLoading === false) {
                    dispatch({ type: RECEIVE_CONFIGURATION_LOADER, isPartnerConfigLoading: true });
                    dispatch({ type: RECEIVE_CONFIGURATION_DATA_LOADER, isPartnerConfigDataLoading: false });
                    services
                        .getPartnerConfig(retailerCode, lookupType, lookupValue)
                        .then((data) => {
                            if (
                                data &&
                                data["retailerName"] &&
                                data["retailerName"].toLowerCase() === defaultRetailer.toLowerCase() &&
                                retailerCode?.toLowerCase() !== defaultRetailer.toLowerCase()
                            ) {
                                let searchparms = decodeURIComponent(encodeURIComponent(window.location.search));
                                searchparms = searchparms.replace("?RetailerCode=", "");
                                if (searchparms && searchparms !== data["retailerName"]) {
                                    let result = decodeURIComponent(encodeURIComponent(window.location.href)).replace(searchparms, data["retailerName"]);
                                    window.location.href = result;
                                }
                            }
                            const appState = getState();
                            console.log('success:: state configurationService ===>>', appState?.configurationState);
                            if (appState.configurationState) {
                                dispatch({
                                    type: RECEIVE_CONFIGURATION,
                                    configuration: {
                                        ...appState.configurationState.configuration,
                                        partnerConfig: data,
                                    },
                                });
                                dispatch({ type: RECEIVE_CONFIGURATION_DATA_LOADER, isPartnerConfigDataLoading: true });
                                if (state != null && state.configurationState != null && !!!state.configurationState.partnerLanguageOptions) {
                                    services.getPartnerLanguageOptions().then((data) => {
                                        if (data) {
                                            dispatch({ type: SET_LANGUAGE_OPTIONS, partnerLanguageOptions: data.partnerLanguageList });
                                        }
                                    });
                                }
                                dispatch({ type: RECEIVE_CONFIGURATION_LOADER, isPartnerConfigLoading: false });
                            }
                        })
                        .catch(function (error) {
                            const appState = getState();

                            console.log('catch:: state configurationService ===>>', appState?.configurationState?.configuration.partnerConfig.partnerId);
                            
                            if (appState.configurationState) {
                                if(appState?.configurationState?.configuration.partnerConfig.partnerId === 2664) {
                                    window.location.href = 'https://my.malwarebytes.com';
                                }
                                dispatch({
                                    type: RECEIVE_CONFIGURATION,
                                    configuration: {
                                        ...appState.configurationState.configuration,
                                        partnerConfig: {},
                                    },
                                });
                                dispatch({ type: RECEIVE_CONFIGURATION_LOADER, isPartnerConfigLoading: false });
                                dispatch({ type: RECEIVE_CONFIGURATION_DATA_LOADER, isPartnerConfigDataLoading: false });
                            }
                        });
                }
                dispatch({ type: REQUEST_CONFIGURATION });
            },

    requestIDFLoginURL: (): AppThunkAction<ConfigurationTypes> => (dispatch, getState) => {
        services
            .getIDFLoginURL()
            .then((data) => {
                const appState = getState();
                if (appState.configurationState) {
                    dispatch({
                        type: RECEIVE_CONFIGURATION,
                        configuration: {
                            ...appState.configurationState.configuration,
                            idfLoginURL: data.idfLoginURL,
                        },
                    });
                }
            })
            .catch(function (error) {
                const appState = getState();
                if (appState.configurationState) {
                    dispatch({
                        type: RECEIVE_CONFIGURATION,
                        configuration: {
                            ...appState.configurationState.configuration,
                            idfLoginURL: "",
                        },
                    });
                }
            });

        dispatch({ type: REQUEST_CONFIGURATION });
    },
    requestCountryList: (IsIDFPartner: boolean,partnerID: number): AppThunkAction<ConfigurationTypes> => (dispatch) => {
        services
            .getCountryList(IsIDFPartner,partnerID)
            .then((data) => {
                if (data.isSuccess) {
                    dispatch({
                        type: GET_COUNTRY_LIST,
                        countryList: data.countryList,
                    });
                } else {
                    dispatch({
                        type: GET_COUNTRY_LIST,
                        countryList: [],
                    });
                }
            })
            .catch(function (error) {
                dispatch({
                    type: GET_COUNTRY_LIST,
                    countryList: [],
                });
            });
    },
    setRedirectToDashboard:
        (redirectToDashboard: boolean): AppThunkAction<ConfigurationTypes> =>
            (dispatch) => {
                dispatch({
                    type: SET_REDIRECT_TO_DASHBOARD,
                    redirectToDashboard,
                });
            },
    setChildAccountSwitchURL:
        (childAccountSwitchRedirectURL: string): AppThunkAction<ConfigurationTypes> =>
            (dispatch) => {
                dispatch({
                    type: SET_CHILD_ACCOUNT_SWITCH_REDIRECT_URL,
                    childAccountSwitchRedirectURL,
                });
            },
    getRedirectTokenAction:
        (redirectToken: string): AppThunkAction<ConfigurationTypes> =>
            (dispatch, getState) => {
                if (!redirectToken) {
                    dispatch({ type: "REDIRECT_TOKEN_URL", redirectToken: "" });
                } else {
                    services.getRedirectionUrl(redirectToken).then((data) => {
                        if (data.isSuccess) {
                            dispatch({ type: "REDIRECT_TOKEN_URL", redirectToken: data.sontiqUrlPath });
                        }
                    });
                }
            },
    getPartnerLanguageOptions: (): AppThunkAction<ConfigurationTypes> => (dispatch, getState) => {
        const state = getState();
        if (
            state != null &&
            state.configurationState != null &&
            !(!!state.configurationState.partnerLanguageOptions && state.configurationState.isPartnerConfigLoading === false)
        ) {
            services.getPartnerLanguageOptions().then((data) => {
                if (data) {
                    dispatch({ type: SET_LANGUAGE_OPTIONS, partnerLanguageOptions: data.partnerLanguageList });
                }
            });
        }
    },
    setRouteLoading:
        (isLoading: boolean): AppThunkAction<ConfigurationTypes> =>
            (dispatch) => {
                dispatch({ type: SET_ROUTE_LOADING, loading: isLoading });
            },
    setUserAuthStatus:
        (userAuthStatus?: string): AppThunkAction<ConfigurationTypes> =>
            (dispatch, getState) => {
                const appState = getState();
                if (appState.configurationState) {
                    dispatch({
                        type: RECEIVE_CONFIGURATION,
                        configuration: {
                            ...appState.configurationState.configuration,
                            userAuthStatus: userAuthStatus,
                        },
                    });
                }
            },

    setUnpaidCidData:
        (cid: string, channel:string): AppThunkAction<ConfigurationTypes> =>
            (dispatch) => {
                dispatch({
                    type: SET_CID_UNPAID_CHANNEL_DATA,
                    cid: cid,
                    channel:channel,
                });
            },

    setSalesTaxData:
        (salesTax: number, annualTax: number): AppThunkAction<ConfigurationTypes> =>
            (dispatch) => {
                dispatch({
                    type: SET_SALES_TAX_DATA,
                    salesTax: salesTax,
                    annualTax: annualTax,
                });
            },

};
